import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';

import { CompareAndMergeDialogComponent } from '../dialogs/compare-and-merge/compare-and-merge.dialog';
import { DocumentVersion } from '../model/document-version.model';
import { WkCompareRequestModel } from '../model/wk-compare-request.model';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';

@Injectable({
  providedIn: 'root',
})
export class WkCompareService {
  contentType = ['application/json'];
  chosenNodes = new Subject<any>();
  targetDocument = new BehaviorSubject<any>('');
  currentDocument = new BehaviorSubject<any>('');
  targetVersion = new BehaviorSubject<any>('');
  currentVersion = new BehaviorSubject<any>('');

  constructor(
    private readonly dialogRef: MatDialog,
    private readonly apiService: WkAlfrescoApiService
  ) {}

  getDiffFile(requestModel: WkCompareRequestModel): Observable<string> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: `alfresco/s/wk/document/comparison`,
        httpMethod: 'POST',
        bodyParam: requestModel,
        contentTypes: this.contentType,
        accepts: this.contentType,
      })
    );
  }

  openCompareAndMergeDialog(): void {
    this.dialogRef.open(CompareAndMergeDialogComponent, {
      width: '700px',
    });
  }

  getVersions(nodeRef: string): Observable<DocumentVersion[]> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: `alfresco/s/wk/document/versions/metadata`,
        httpMethod: 'GET',
        queryParams: { nodeRef },
        contentTypes: this.contentType,
        accepts: this.contentType,
      })
    );
  }

  getChosenNodes() {
    return this.chosenNodes.asObservable();
  }

  setCurrentVersion(currentVersion) {
    this.currentVersion.next(currentVersion);
  }

  getCurrentVersion() {
    return this.currentVersion.asObservable();
  }

  setTargetVersion(targetVersion) {
    this.targetVersion.next(targetVersion);
  }

  getTargetVersion() {
    return this.targetVersion.asObservable();
  }

  setCurrentDocument(currentDoc) {
    this.currentDocument.next(currentDoc);
  }

  getCurrentDocument() {
    return this.currentDocument.asObservable();
  }

  setTargetDocument(targetDoc) {
    this.targetDocument.next(targetDoc);
  }

  getTargetDocument() {
    return this.targetDocument.asObservable();
  }
}
